import React, { useState, useRef, useEffect } from 'react';
import './styles/Home.css';
import Header from './components/Header';
import Footer from './components/Footer';

const Home = () => {
  const movebox1Ref = useRef(null);
  const movebox2Ref = useRef(null);
  const movebox3Ref = useRef(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [clickedIndex, setClickedIndex] = useState(null);

  const handleMouseEnter = (index) => {
    if (clickedIndex !== index) {
      setHoveredIndex(index);
    }

    if (index === 1) {
      movebox1Ref.current?.classList.add('moveRight');
      movebox2Ref.current?.classList.add('moveRight');
      movebox3Ref.current?.classList.add('moveRight');
    } else if (index === 2) {
      movebox1Ref.current?.classList.add('moveleft');
      movebox2Ref.current?.classList.add('moveRight');
      movebox3Ref.current?.classList.add('moveRight');
    } else if (index === 3) {
      movebox3Ref.current?.classList.add('moveRight');
    }
  };

  const handleMouseLeave = (index) => {
    if (clickedIndex === index) return; // Don’t remove if it's toggled on

    setHoveredIndex(null);

    if (index === 1) {
      movebox1Ref.current?.classList.remove('moveRight');
      movebox2Ref.current?.classList.remove('moveRight');
      movebox3Ref.current?.classList.remove('moveRight');
    } else if (index === 2) {
      movebox1Ref.current?.classList.remove('moveleft');
      movebox2Ref.current?.classList.remove('moveRight');
      movebox3Ref.current?.classList.remove('moveRight');
    } else if (index === 3) {
      movebox3Ref.current?.classList.remove('moveRight');
    }
  };
  const resetAnimations = () => {
    movebox1Ref.current?.classList.remove('moveRight', 'moveleft');
    movebox2Ref.current?.classList.remove('moveRight');
    movebox3Ref.current?.classList.remove('moveRight');
  };
  const handleClick = (index) => {
    if (clickedIndex === index) {
      setClickedIndex(null);
      setHoveredIndex(null);
      resetAnimations();
      return;
    }

    resetAnimations();

    setClickedIndex(index);
    setHoveredIndex(index);
    handleMouseEnter(index);
  };

  const useIntersection = (options) => {
    const ref = useRef(null);
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      }, options);

      if (ref.current) {
        observer.observe(ref.current);
      }

      return () => {
        if (ref.current) observer.unobserve(ref.current);
      };
    }, [ref, options]);

    return [ref, isVisible];
  };

  const [slideRef, isVisible] = useIntersection({ threshold: 0.3 });

  const [selectedExpertise, setSelectedExpertise] = useState(null);
  const defaultExpertiseText = "Services Here At KWA";

  const expertiseMessages = {
    1: 'Litigation refers to the process of resolving disputes through the court system. It includes various steps, from filing a lawsuit to presenting a case in court. There are two primary types of litigation: Criminal and Civil. Criminal cases involve the government prosecuting someone for breaking the law, like theft or assault. For example, if someone is caught robbing a store, they may face criminal charges and could go to jail if found guilty. Civil cases are disputes between people or businesses, often over money or contracts. Imagine you hire a contractor to build a deck, but they don’t finish the job. You could sue for damages in civil court to get your money back or the work completed.',

    2: 'Cheque bouncing occurs when a bank refuses to honor a cheque due to insufficient funds or other issues, making the issuer liable for legal action. For instance, if you give a friend a cheque to repay a loan, but they don’t have enough money in their account to cover it, the cheque bounces. Under Section 138 of the NI Act, you can file a complaint against them for this non-payment, which could lead to penalties, including fines or imprisonment.',

    3: 'Family matters encompass legal issues such as divorce, child custody, and alimony. For example, during a divorce, a couple may need to determine custody arrangements for their children, which can involve negotiations and legal proceedings to ensure the best interests of the child are met. A will is a legal document that outlines how a person wants their assets distributed after their death. For instance, if someone wants to leave their house to their children, they would specify this in their will, ensuring their wishes are honored and reducing potential disputes among heirs. Succession refers to the legal process of transferring a deceased person’s assets to their heirs. Imagine a person passes away without a will; their assets would be distributed according to state laws on intestate succession, which can lead to disagreements among family members if they are not clearly defined.',

    4: 'Revenue and land disputes arise over issues such as land ownership, property tax assessments, or illegal encroachments. For example, if two neighbors claim ownership of the same piece of land, they may engage in a legal battle to prove their claims, potentially involving government authorities to resolve the matter. Other land matters include land use regulations, zoning laws, and title disputes. For instance, if a developer wants to build a shopping center but the land is zoned for residential use, they may need to seek a zoning change through legal channels to proceed with their project.',

    5: 'Commercial laws govern business transactions and practices, ensuring fairness and legality in the marketplace. For example, if a company sells defective products, commercial laws allow consumers to seek remedies, such as refunds or replacements, protecting their rights as buyers. Contractual laws focus on the creation and enforcement of agreements between parties. For instance, if you sign a lease agreement for an apartment, contractual laws ensure that both you and the landlord fulfill your obligations, such as paying rent on time and maintaining the property.',

    6: 'Consumer protection laws are designed to safeguard buyers from unfair or deceptive business practices and ensure their rights are upheld. For example, if a company advertises a product as 100% organic but it contains synthetic ingredients, consumers can file complaints under these laws to seek refunds or compensation for misleading claims.',

    7: 'Conciliation is a voluntary process where a neutral third party helps disputing parties reach an amicable settlement. For example, in a workplace conflict between an employee and employer, a conciliator can facilitate discussions to find a mutually agreeable solution, helping to avoid litigation and maintain a good working relationship. Arbitration is a more formal dispute resolution process where a neutral arbitrator makes a binding decision after hearing both sides. For instance, if two businesses have a disagreement over a contract, they may choose arbitration, where the arbitrator\'s decision is final, allowing them to resolve the issue without going to court.',

    8: 'Intellectual property rights laws protect creations of the mind, giving creators exclusive rights to use and profit from their work. IPR includes various forms such as copyright (for artistic works), patents (for inventions), trademarks (for brand identifiers), and trade secrets (for confidential business information). For instance, if a company invents a new smartphone feature, it can apply for a patent. This patent prevents others from using the feature without permission for a specified period, ensuring the company can profit from its innovation and maintain a competitive edge.',

    9: 'Corporate laws govern the formation, operation, and dissolution of companies. They establish the rights and responsibilities of corporations, shareholders, and directors, ensuring compliance with legal standards. For example, when a startup decides to incorporate, corporate laws guide its structure, such as the issuance of shares and the responsibilities of its board of directors. Banking laws regulate financial institutions and their operations, ensuring consumer protection and maintaining the stability of the financial system. They cover aspects such as licensing, capital requirements, and anti-money laundering regulations. For instance, if a bank wants to offer loans, it must adhere to banking laws that govern interest rates and lending practices, protecting consumers from predatory lending.'
  };

  const handleExpertiseClick = (index) => {
    setSelectedExpertise(index);
  };

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 900) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className='HomeBody'>
      <Header scrolled={scrolled} />
      <div className='position-relative hovercontent justify-content-center align-items-center'>
        <div style={{ width: '65%', height: '4px', backgroundColor: '#cd7f32' }}></div>
        <div className='position-absolute d-flex gap-5 justify-content-center hoverParentDiv'>
          <div className='d-flex flex-column align-items-start hoverBox'
            ref={movebox1Ref}
            onMouseEnter={() => handleMouseEnter(1)}
            onMouseLeave={() => handleMouseLeave(1)}
            onClick={() => handleClick(1)}
          >
            <div className='circle'></div>
            <div
              className='hoverTextMain'
            >
              We are
            </div>
            {hoveredIndex === 1 && (
              <div className='hoverText position-absolute' style={{ transform: 'translate(0px,37%)', width: '24vw' }}>
                Full service law firm catering to all the needs of litigating parties looking for genuine and practical legal advice and representation before various forums requiring legal acumen and experience.
              </div>
            )}
          </div>

          <div className='d-flex flex-column align-items-start hoverBox'
            ref={movebox2Ref}
            onMouseEnter={() => handleMouseEnter(2)}
            onMouseLeave={() => handleMouseLeave(2)}
            onClick={() => handleClick(2)}
          >
            <div className='circle'></div>
            <div
              className='hoverTextMain'
            >
              At KWA
            </div>
            {hoveredIndex === 2 && (
              <div className='hoverText position-absolute' style={{ transform: 'translate(0px,88%)', width: '24vw' }}>
                Client satisfaction and best efforts to fetch the desired relief remain
              </div>
            )}
          </div>

          <div
            className='d-flex flex-column align-items-start hoverBox'
            ref={movebox3Ref}
            onMouseEnter={() => handleMouseEnter(3)}
            onMouseLeave={() => handleMouseLeave(3)}
            onClick={() => handleClick(3)}
          >
            <div className='circle'></div>
            <div
              className='hoverTextMain'
            >
              We here
            </div>
            {hoveredIndex === 3 && (
              <div className='hoverText position-absolute' style={{ transform: 'translate(0px,87%)', width: '230px' }}>
                We espouse the cause of our client as our own.
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='flex-column position-relative justify-content-around align-items-center hovercontentVertical w-100'>
        <div>We are a full service law firm catering to all the needs of litigating parties looking for genuine and practical legal advice and representation before various forums requiring legal acumen and experience.</div>
        <div>At KWA, client satisfaction and best efforts to fetch the desired relief remain</div>
        <div>Here we espouse the cause of our client as our own.</div>
      </div>
      <div
        ref={slideRef}
        className={`onSlideDiv w-100 d-flex justify-content-center align-items-center fade-in-section position-relative ${isVisible ? 'is-visible' : ''}`}
        style={{ padding: '20%', zIndex: '101' }}
      >
        <div className='homemainText' style={{ color: 'white' }}>At KWA, we firstly understand the needs and interest of our client and we adopt an inclusive approach where we ensure to keep our client completely in the loop at all levels of discussion and decision making. The client remains aware of the strategy to be adopted and the actual execution of the same in the Courts of law and before various forums of law which further augments the trust quotient between us and our valued clients.</div>
      </div>
      <div className='moreinfo p-5 flex-column align-items-center w-100'>
        <div style={{paddingTop: '5%',display: 'flex',flexDirection: 'column',alignItems: 'center',justifCcontent: 'space-between',height: '100%'}}>
          <div className='moreinfotitle fw-bold d-flex'>We care about our customers stuck in...</div>
          <div className='d-flex gap-5 h-100'>
            <div className='p-5 py-1 h-100 moreinfoBoxdiv1'>
              <div className='moreinfoSelectors d-flex flex-column w-100 h-100 justify-content-center align-items-start'>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(1)}>Criminal & Civil litigation</div>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(2)}>Cheque Bouncing</div>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(3)}>Family matters, Wills & Succession</div>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(4)}>Revenue and Land Disputes & other Land matters</div>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(5)}>Commercial and Contractual Laws</div>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(6)}>Consumer Protection laws</div>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(7)}>Conciliation and Arbitration</div>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(8)}>Intellectual Property Rights Laws</div>
                <div className='moreinfoselection' onClick={() => handleExpertiseClick(9)}>Corporate & Banking</div>
              </div>
            </div>
            <div className='p-5 d-flex justify-content-center align-items-center h-100 moreinfoBoxdiv2'>
              <div className='moreinfoBox p-3 d-flex justify-content-center mt-4 text-center fs-5' style={{ width: '100%' }}>
                <span className='moreinfotext'>{selectedExpertise ? expertiseMessages[selectedExpertise] : defaultExpertiseText}</span>
              </div>
            </div>
          </div>
        </div>        
      </div>
      <div className='moreinfoSmall w-100'>
        <div id="carouselExampleIndicators" className="carousel slide w-100 justify-content-center align-items-center d-flex" style={{height:'91vh'}} data-bs-ride="false" >
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="6" aria-label="Slide 7"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="7" aria-label="Slide 8"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="8" aria-label="Slide 9"></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className=" w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                  <h2>Criminal & Civil litigation</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Litigation refers to the process of resolving disputes through the court system. It includes various steps, from filing a lawsuit to presenting a case in court. There are two primary types of litigation: Criminal and Civil. Criminal cases involve the government prosecuting someone for breaking the law, like theft or assault. For example, if someone is caught robbing a store, they may face criminal charges and could go to jail if found guilty. Civil cases are disputes between people or businesses, often over money or contracts. Imagine you hire a contractor to build a deck, but they don’t finish the job. You could sue for damages in civil court to get your money back or the work completed.
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className=" w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                <h2>Cheque Bouncing</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Cheque bouncing occurs when a bank refuses to honor a cheque due to insufficient funds or other issues, making the issuer liable for legal action. For instance, if you give a friend a cheque to repay a loan, but they don’t have enough money in their account to cover it, the cheque bounces. Under Section 138 of the NI Act, you can file a complaint against them for this non-payment, which could lead to penalties, including fines or imprisonment.
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className=" w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                <h2>Family matters, Wills & Succession</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Family matters encompass legal issues such as divorce, child custody, and alimony. For example, during a divorce, a couple may need to determine custody arrangements for their children, which can involve negotiations and legal proceedings to ensure the best interests of the child are met. A will is a legal document that outlines how a person wants their assets distributed after their death. For instance, if someone wants to leave their house to their children, they would specify this in their will, ensuring their wishes are honored and reducing potential disputes among heirs. Succession refers to the legal process of transferring a deceased person’s assets to their heirs. Imagine a person passes away without a will; their assets would be distributed according to state laws on intestate succession, which can lead to disagreements among family members if they are not clearly defined.
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className=" w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                <h2>Revenue and Land Disputes & other Land matters</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Revenue and land disputes arise over issues such as land ownership, property tax assessments, or illegal encroachments. For example, if two neighbors claim ownership of the same piece of land, they may engage in a legal battle to prove their claims, potentially involving government authorities to resolve the matter. Other land matters include land use regulations, zoning laws, and title disputes. For instance, if a developer wants to build a shopping center but the land is zoned for residential use, they may need to seek a zoning change through legal channels to proceed with their project.
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className=" w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                <h2>Commercial and Contractual Laws</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Commercial laws govern business transactions and practices, ensuring fairness and legality in the marketplace. For example, if a company sells defective products, commercial laws allow consumers to seek remedies, such as refunds or replacements, protecting their rights as buyers. Contractual laws focus on the creation and enforcement of agreements between parties. For instance, if you sign a lease agreement for an apartment, contractual laws ensure that both you and the landlord fulfill your obligations, such as paying rent on time and maintaining the property.
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className=" w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                <h2>Consumer Protection laws</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Consumer protection laws are designed to safeguard buyers from unfair or deceptive business practices and ensure their rights are upheld. For example, if a company advertises a product as 100% organic but it contains synthetic ingredients, consumers can file complaints under these laws to seek refunds or compensation for misleading claims.
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className="w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                <h2>Conciliation and Arbitration</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Conciliation is a voluntary process where a neutral third party helps disputing parties reach an amicable settlement. For example, in a workplace conflict between an employee and employer, a conciliator can facilitate discussions to find a mutually agreeable solution, helping to avoid litigation and maintain a good working relationship. Arbitration is a more formal dispute resolution process where a neutral arbitrator makes a binding decision after hearing both sides. For instance, if two businesses have a disagreement over a contract, they may choose arbitration, where the arbitrator's decision is final, allowing them to resolve the issue without going to court.
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className=" w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                <h2>Intellectual Property Rights Laws</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Intellectual property rights laws protect creations of the mind, giving creators exclusive rights to use and profit from their work. IPR includes various forms such as copyright (for artistic works), patents (for inventions), trademarks (for brand identifiers), and trade secrets (for confidential business information). For instance, if a company invents a new smartphone feature, it can apply for a patent. This patent prevents others from using the feature without permission for a specified period, ensuring the company can profit from its innovation and maintain a competitive edge.
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div className=" w-100 py-3 flex-column d-flex justify-content-between align-items-center">
                <div className='text-center'>
                <h2>Corporate & Banking</h2>
                </div>
                <div className="carouselText text-center px-3">
                  Corporate laws govern the formation, operation, and dissolution of companies. They establish the rights and responsibilities of corporations, shareholders, and directors, ensuring compliance with legal standards. For example, when a startup decides to incorporate, corporate laws guide its structure, such as the issuance of shares and the responsibilities of its board of directors. Banking laws regulate financial institutions and their operations, ensuring consumer protection and maintaining the stability of the financial system. They cover aspects such as licensing, capital requirements, and anti-money laundering regulations. For instance, if a bank wants to offer loans, it must adhere to banking laws that govern interest rates and lending practices, protecting consumers from predatory lending.
                </div>
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;